import { ChartOptionsProvider } from './chart-options';
import { Injectable } from '@angular/core';

@Injectable()
export class HistoricSharePriceOptionsProvider extends ChartOptionsProvider {
  getOptions(company) {
    if (!company.historic_share_price_new) {
      return ;
    }
    const historicSharePrice = company.historic_share_price_new;
    const sharePrice = company.platformData.sharePrice;
    const currentDate = new Date();
    currentDate.setHours(1,0,0,0);

    let chartOptions = {
      chart: { spacingBottom: 20, type: 'line' },
      title: `Share Price (${company.platformData.currencyUnit})`,
      legend: {
        enabled: false
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          year: '%Y'
        }
      },
      yAxis: {
        labels:{
            x:0
        },
        min: 0,
        max: Math.max(...historicSharePrice.map(item => parseFloat(item.value))) + 0.1,
        title: {
          text: null
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size: 10px">{point.key:%e %b %Y}</span><br/>',
        pointFormat: "{series.name}: {point.y:.2f}"
      },
      series: [
        {
          name: 'Share Price',
          data: [...historicSharePrice.map(item => [new Date(item.date).getTime(), parseFloat(item.value)]), [currentDate.getTime(), sharePrice] ],
          marker: {
            enabled: false
          },
          visible: true
        }]
    }
    chartOptions = this.setYMax(chartOptions);
    return super.getOptions(company, chartOptions);
  };
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/historic-share-price.ts